import { render } from "./TestResultAssteacher.vue?vue&type=template&id=eea23eca&scoped=true"
import script from "./TestResultAssteacher.vue?vue&type=script&lang=js"
export * from "./TestResultAssteacher.vue?vue&type=script&lang=js"

import "./TestResultAssteacher.vue?vue&type=style&index=0&id=eea23eca&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eea23eca"]])

export default __exports__